var React = require('react');

function X2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.74824e-05 3.48219L2.83643 0.696477L39 36.2143L36.1636 39L6.74824e-05 3.48219Z","fill":"#9FAEE2","key":0}),React.createElement("path",{"d":"M36.1636 0L38.9999 2.78571L2.83636 38.3035L0 35.5178L36.1636 0Z","fill":"#9FAEE2","key":1})]);
}

X2.defaultProps = {"width":"39","height":"39","viewBox":"0 0 39 39","fill":"none"};

module.exports = X2;

X2.default = X2;
